<template>
  <div id="app">
    <router-view></router-view>
    <music></music>
    <!-- <lcb-toast></lcb-toast> -->
    <div v-if="showQR" class="app-store-pop-box" @click="hideShowQR">
      <div class="app-store-pop" :class="showQR && 'transPop'">
        <div class="app-store-img">
          <p>请使用手机扫描下方二维码进行预约</p>
          <img :src="AppStoreQR" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
// import LcbToast from "@/components/LcbToast";
import Music from "@/components/Music";
import tool from '@/libs/utils.js'

const defaultList = [{ catname: "最新", catid: '' }];
export default {
  name: "App",
  components: {
    // LcbToast,
    Music
  },
  data() {
    return {
      AppStoreQR: "",
      content12: "",
      test: false
    };
  },
  computed: {
    ...mapState(["showQR", "channel", "tabsList"])
  },
    created(){
    if(tool.checkOperaSys() !== 'pc'){
      let url = `${process.env.VUE_APP_M_URL}`;
      let params = tool.getUrlParam();
      const urlParams = tool.combinationUrlParam(params);
      if(urlParams){
        url += `?${urlParams}`
      }
      window.location.href = url
    }
  },
  mounted() {
    this.getContact();
    this.getDown();
    this.getType();
  },
  methods: {
    ...mapActions(["setShowQR", "changeDown", "setContact", "setNewsTabList"]),
    hideShowQR() {
      this.setShowQR(false);
    },
    /**
     * 二维码
     */
    async getContact() {
      try {
        const {
          data: { items }
        } = await this.$api.getKMSConfig("contact", { f: "data" });
        if (items.length === 0) return;
        this.setContact(items[0]);
        this.AppStoreQR = items[0].appQr;
      } catch (error) {
        this.$toast(error?.desc || "Error");
      }
    },
    /**
     * 下载
     */
    async getDown() {
      try {
        const {
          data: { items }
        } = await this.$api.getKMSConfig("download", { f: "data" });
        if (items.length === 0) return;
        const down = items.filter(item => item.channel === this.channel);
        this.changeDown(down[0]);
      } catch (error) {
        this.$toast(error?.desc || "Error");
      }
    },
    async getType(){
      try {
        const {
          data: { items }
        } = await this.$api.getKMSConfig("column");
        if (items.length === 0) return;
        this.setNewsTabList(defaultList.concat(items.reverse()))
      } catch (error) {
        this.$toast(error?.desc || "Error");
      }
    }
  }
};
</script>

<style lang="less">
@import "./assets/css/mixin.less";
html,
body {
  // .mixin_fs();
  .mixin_fsw();
}
#app {
  margin: 0 auto;
  font-family:
    "Microsoft YaHei",
    Avenir,
    Helvetica,
    "Arial",
    "黑体",
    "宋体",
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.clearfix::after {
  display: block;
  height: 0;
  clear: both;
  visibility: hidden;
  content: ".";
}
.clearfix {
  display: inline-block;
}
.section {
  position: relative;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  .section-con {
    max-width: 100%;
    height: 100% !important;
    margin: auto;
  }
  .content-pos {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 1;
  }
}
.section.active {
  .animation(scaleA 1.3s ease both);
}
.age16 {
  position: absolute;
  .mixin_com(right, 50);
  .mixin_com(bottom, 26);
  .mixin_com(width, 73);
  .mixin_com(height, 94);

  cursor: pointer;
  background: url("~@/assets/images/age12.png") no-repeat center;
  background-size: contain;
  transition: all 0.3s;
  &:hover {
    transform: scale(1.03);
  }
}

.van-toast {
  padding: 30px 50px;
  font-size: 20px;
  background-color: rgba(0, 0, 0, 0.8);
  box-shadow: 0 0 10px #000;
}
.app-store-pop-box {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 50;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  background: rgba(8, 8, 11, 0.7);
  .transform(translateY(0%));
}
.app-store-pop {
  color: #fff;
  text-align: center;
  p {
    .mixin_com(margin-top, 32);
    .mixin_com(margin-bottom, 10);
    .mixin_com(font-size, 14);
  }
  .app-store-img {
    .mixin_com(width, 274);
    .mixin_com(height, 345);

    overflow: hidden;
    background: url("~@/assets/images/section5/aboutbg.png") no-repeat 0 0;
    background-size: 100% auto;
  }
  img {
    .mixin_com(width, 200);
  }
}
.age12-pop-box {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 50;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  background: rgba(8, 8, 11, 0.7);
  .transform(translateY(0%));
}
.age12-pop {
  position: relative;
  .mixin_com(width, 992);
  .mixin_com(height, 521);
  .mixin_com(font-size, 18);

  color: #c7c7c7;
  background: url("~@/assets/images/bg16.png") no-repeat left top / cover;

  .age-txt {
    height: 87%;
    margin: 0 auto;
    .mixin_com(margin-top, 30);
    .mixin_com(margin-bottom, 30);
    .mixin_com(margin-left, 30);
    .mixin_com(margin-right, 30);

    overflow-x: hidden;
    overflow-y: auto;
    line-height: 1.6;
    .transform(translateY(0%));
  }

  .age-txt::-webkit-scrollbar {
    /* 滚动条整体样式 */
    width: 8px; /* 高宽分别对应横竖滚动条的尺寸 */
    height: 8px;
    scrollbar-arrow-color: red;
  }
  .age-txt::-webkit-scrollbar-thumb {
    background: rgba(218, 218, 218, 0.2);

    /* 滚动条里面小方块 */
    border-radius: 5px;
    -webkit-box-shadow: inset 0 0 5px rgba(218, 218, 218, 0.2);
    box-shadow: inset 0 0 5px rgba(218, 218, 218, 0.2);
    scrollbar-arrow-color: red;
  }
  .age-txt::-webkit-scrollbar-track {
    background: rgba(218, 218, 218, 0.1);
    border-radius: 0;

    /* 滚动条里面轨道 */
    -webkit-box-shadow: inset 0 0 5px rgba(218, 218, 218, 0.2);
    box-shadow: inset 0 0 5px rgba(218, 218, 218, 0.2);
  }
}
.close {
  position: absolute;
  top: 0;
  .mixin_com(right, -35);
  .mixin_com(width, 24);
  .mixin_com(height, 24);

  text-indent: -9999px;
  cursor: pointer;
  background: url("~@/assets/images/close16.png") no-repeat left top / cover;
}
.transPop {
  .animation(fadeInDown 0.3s);
}
.active {
  .up-ani {
    .animation(fadeInUp 1s 0.3s ease both);
  }
}

@media screen and (max-aspect-ratio: ~"1920/1080") {
  html,
  body {
    .mixin_fsw();
  }
  .section {
    display: flex;
    align-content: center;
    .section-con {
      width: 100%;
      max-width: 100%;
      height: auto;
      margin: auto;
    }
    .fullpage-item-holder {
      width: 100%;
      height: auto;
    }
    .fp-tableCell {
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}
</style>
